<template>
    <div
        class="grid animate-pulse grid-cols-2 gap-x-4 gap-y-8 sm:grid-cols-4"
        data-spec-class="tabs-skeleton"
    >
        <div class="h-8 rounded-sm bg-muted" />
        <div class="h-8 rounded-sm bg-secondary--inverse" />
    </div>
</template>
